<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-phone-in-talk"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :sort-by="['id']"
              :sort-desc="true"
              :items="consultation"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-eye
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog
          v-model="viewDetail"
          max-width="500px"
          persistent
      >
        <v-card class="pa-4">
          <v-card-title>
            <span class="text-h5 mx-3">Detail consultation</span>
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col class="my-4" cols="11">
                <v-text-field
                    v-model="consultationDetail.name"
                    filled
                    label="Name"
                    readonly
                ></v-text-field>
                <v-text-field
                    v-model="consultationDetail.phone"
                    filled
                    label="Phone"
                    readonly
                ></v-text-field>
                <v-text-field
                    v-model="consultationDetail.email"
                    filled
                    label="Email"
                    readonly
                ></v-text-field>
                <v-textarea
                    v-model="consultationDetail.message"
                    filled
                    label="Message"
                    readonly
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row align="center" justify="center">
              <v-btn class="mr-5" @click="viewDetail = false">CLOSE</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_DETAIL_CONSULTATION, GET_LIST_CONSULTATION} from "@/store/modules/consultationForm";

export default {
  name: "ConsultationForm",
  data() {
    return {
      page: "Danh sách consultation",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách consultation",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'Phone', value: 'phone'},
        {text: 'Email', value: 'email'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      viewDetail: false,

    }
  },
  computed: {
    ...mapGetters({
      consultation: "consultation",
      consultationDetail: "consultationDetail",
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_CONSULTATION);
  },
  methods: {
    editItem(id) {
      this.$store.dispatch(`${GET_DETAIL_CONSULTATION}`, id).then((data) => {
        if (data) {
          this.viewDetail = true;
        }
      });
    },
  }
}
</script>

<style scoped>

</style>